'use strict';

module.exports = require('react/lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// ./~/react-dom/index.js
// module id = 157
// module chunks = 0 1 2 3 4 5 7 8 9 10 11 12 13